import cubeClient from "../../cubeClient"
import { CubeRequestParams } from "../../types"

export const fetchAdditionalClassesTableData = async (details: {
  queryFilters: any[]
  queryOrder: Record<string, string>
  timeDimensions: any
  limit: number
  offset: number
  basicDataTablePromise: Promise<any>
  requestParams: Record<string, Record<string, CubeRequestParams>>
}): Promise<any> => {
  const {
    queryFilters,
    queryOrder,
    timeDimensions,
    limit,
    offset,
    requestParams,
    basicDataTablePromise
  } = details

  const isFilterByStudent = !!queryFilters.find(item =>
    item.member?.includes("studentId")
  )

  if (isFilterByStudent) {
    const basicTableData = await basicDataTablePromise
    const classesIds = basicTableData
      .filter(item => !!item)
      .map(item => item["org_view_classes.id"])

    if (!classesIds.length) {
      return []
    }

    const additionalTableData = await cubeClient.get("/", {
      params: {
        query: JSON.stringify({
          ...requestParams.organization.classesByStudent,
          filters: [
            {
              member: "org_view_classes.id",
              operator: "equals",
              values: classesIds
            }
          ],
          ...(!!queryOrder ? { order: queryOrder } : {}),
          ...timeDimensions,
          limit,
          offset
        })
      }
    })

    if (!additionalTableData?.length) return []

    const orderFieldName = Object.keys(queryOrder?.order || {})?.[0]

    const isAdditionalDataOrder = [
      "org_view_classes.id",
      "org_view_classes.studentsCount",
      "org_view_classes.averageTimeSpent",
      "org_view_classes.activeStudentsCount"
    ].includes(orderFieldName)

    return (
      isAdditionalDataOrder ? additionalTableData : basicTableData
    )?.reduce((res, item) => {
      const basicItem = (
        isAdditionalDataOrder ? basicTableData : additionalTableData
      ).find(
        basicItem =>
          basicItem["org_view_classes.id"] === item["org_view_classes.id"]
      )

      if (!basicItem) return res

      return [
        ...res,
        {
          ...basicItem,
          ...item
        }
      ]
    }, [])
  }

  return basicDataTablePromise
}
